import { render, staticRenderFns } from "./LeadRowCount.vue?vue&type=template&id=22c56ff6&"
import script from "./LeadRowCount.vue?vue&type=script&lang=js&"
export * from "./LeadRowCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports